import { Box, Grid, useMediaQuery } from '@mui/material';

import Ayee from 'assets/images/ayee_circle_skin.webp';
import React from 'react';
import { SimButton } from 'components/SimButton';
import SimCircleBanner from 'components/SimCircleBanner';
import { SimTypography } from 'components/SimTypography';
import { useTheme } from '@mui/material/styles';

const ServiceBanner = () => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});

	const LeftSide = () => (
		<Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
			<Box
				marginBottom={{ xs: 2, sm: 2, md: 2, lg: 2 }}
				maxWidth={{ md: '40vw', lg: '85vw' }}
				paddingRight={{ lg: 2 }}>
				<Box display='flex' flexDirection={'column'} alignItems='flex-start'>
					<SimTypography
						color={theme.palette.text.headerLight}
						variant='h4'
						align={'left'}
						data-aos={'fade-up'}
						sx={{
							fontWeight: 700,
							marginTop: theme.spacing(1)
						}}>
						Research based therapy emphasizing holistic child development
					</SimTypography>

					<SimTypography
						paddingTop={2}
						color={theme.palette.text.bodyLight}
						variant='h6'
						align={'left'}
						paddingBottom={0}
						data-aos={'fade-up'}>
						<Box component='span' sx={{ color: theme.palette.secondary.main }}>
							Essentials
						</Box>{' '}
						- delivers screening (autism, behavior & development) and therapies (ABA, Feeding, Speech,
						Language & Occupational) for children under the age of ten at home or in facility.
					</SimTypography>

					<SimTypography
						paddingTop={2}
						color={theme.palette.text.bodyLight}
						variant='h6'
						align={'left'}
						paddingBottom={0}
						data-aos={'fade-up'}>
						<Box component='span' sx={{ color: theme.palette.secondary.main }}>
							ParentEd
						</Box>{' '}
						- offers personalized educational and emotional support resources to parents and care givers
						delivered by leading experts.
					</SimTypography>

					<Box marginY={2} width={1} display={'flex'} justifyContent='flex-end'>
						<Box>
							<SimButton
								variant='contained'
								backgroundColor={theme.palette.background.btnSecondaryCTA}
								color={theme.palette.text.btnSecondaryCTA}
								size='large'
								href={'/services'}>
								Schedule Screening
							</SimButton>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);

	return (
		<Grid container spacing={1} paddingBottom={-4} marginBottom={0}>
			<Grid item container xs={12} md={7}>
				<Box
					data-aos={isMd ? 'fade-right' : 'fade-up'}
					paddingTop={{ xs: 0, sm: 0, md: 2, lg: 2 }}
					width={'100%'}>
					<LeftSide />
				</Box>
			</Grid>

			<Grid
				item
				container
				alignItems={'flex-start'}
				justifyContent={'flex-end'}
				xs={12}
				md={5}
				data-aos='flip-left'
				data-aos-easing='ease-out-cubic'
				data-aos-duration='2000'
				zIndex={2}>
				<SimCircleBanner paddingTop={{ xs: 0, sm: 0, md: 2, lg: 5 }} src={Ayee} />
			</Grid>
		</Grid>
	);
};

export { ServiceBanner };
